import { Bar, Container } from '../styled';
export function LoadingBars(props) {
    const { size = 'md', className } = props;
    return (<Container className={className} aria-hidden="true" $size={size}>
      <Bar />
      <Bar />
      <Bar />
    </Container>);
}
